var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    { staticClass: "director-block", attrs: { href: _vm.hrefLink } },
    [
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.collapsed,
              expression: "collapsed"
            }
          ],
          staticClass: "director-block--inner",
          attrs: {
            "data-event-category": "discover",
            "data-event-action": "info",
            "data-event-label": _vm.director.name
          }
        },
        [
          _c("div", { staticClass: "collaborator-detail-wrapper" }, [
            _c(
              "span",
              [
                _c("profile-picture-initial", {
                  attrs: { src: _vm.profileImageUrl, size: 92 }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", [
              _c("span", { staticClass: "stylized director-block__name" }, [
                _vm._v(_vm._s(_vm.director.name))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "stylized director-block__role" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.role
                        .replace(/(?:^|\s|[-"'([{])+\S/g, function(c) {
                          return c.toUpperCase()
                        })
                        .replace(/[^a-zA-Z ]/g, " ")
                    )
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.collapsed && _vm.index < 5,
              expression: "!collapsed && index<5"
            }
          ]
        },
        [
          _c("profile-picture-initial", {
            attrs: {
              name: _vm.director.name,
              src: _vm.profileImageUrl,
              size: 24
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }